import Modal from '../../../../../commons/Modal/Modal';
import DashboardCommerciauxUpdateForm from './DashboardCommerciauxUpdateForm/DashboardCommerciauxUpdateForm';
import { DashboardCommerciauxUpdateModalProps } from './DashboardCommerciauxUpdateModal.types';

export default (props: DashboardCommerciauxUpdateModalProps) => {
  return (
    <Modal {...props}>
      <DashboardCommerciauxUpdateForm />
    </Modal>
  );
};
